import React from 'react';
import { Spinner } from 'reactstrap';
import { FetchStatus } from '../../../../redux/appState';

type TLoaderProps = {
    status: FetchStatus;
    children: React.ReactNode;
};

export const Loader: React.FC<TLoaderProps> = ({ status, children }: TLoaderProps) => {
    switch (status) {
        default:
        case 'idle':
            return <></>;

        case 'loading':
            return (
                <div className="m-3 text-center">
                    <Spinner />
                </div>
            );

        case 'succeeded':
            return <>{children}</>;
    }
};
